import BsjSetMaxSpeedSmsModal from './bsj-set-max-speed-sms-modal.vue'
export default BsjSetMaxSpeedSmsModal
